/**
 * Language Hook
 * @module chassis/hooks/useLanguage
 * 
 * Provides the current language for i18n translations.
 * TODO: Connect to user preferences or context when available
 */

import type { Language } from '@/chassis/ui/i18n/i18n-helper';
import { useLanguageContext } from '@/chassis/ui/i18n/LanguageProvider';

/**
 * Get the current application language
 * @returns The current language code
 */
export function useLanguage(): Language {
    const { language } = useLanguageContext();
    return language;
}

/**
 * Access language controls (current language, setter, and supported list)
 */
export function useLanguageControls() {
    return useLanguageContext();
}
